export const environment = {
  production: false,
    url_point:'https://72qaclientportalapi.cx360.net'
  };